export const SET_EDITING = "SET_EDITING";



// WEBPACK FOOTER //
// ./src/store/actions/editing.js